import cx from 'classnames';
import dayjs from 'dayjs';
import { useEffect, useRef, useState } from 'react';
import SaleCountdown from './SaleCountdown';

/**
 * @typedef Props
 * @prop {string=} Props.endedText
 * @prop {string=} Props.prefix
 * @prop {string=} Props.suffix
 * @prop {boolean=} Props.useRedText
 * @prop {Date | string} Props.until
 */

/**
 * @param {Props} props
 */
export default function TimeLeft({
  endedText = '',
  prefix = '',
  suffix = '',
  until,
  useRedText = false,
}) {
  const now = new Date();
  const untilDate = new Date(until);
  const diffMs = untilDate.getTime() - now.getTime();
  const isEndingSoon = diffMs > 0 && diffMs <= 60 * 60 * 1000;
  const [, setUpdateCount] = useState(0);
  const [refreshRate] = useState(60);
  const interval = useRef(null);

  useEffect(() => {
    if (interval.current) window.clearInterval(interval.current);

    interval.current = window.setInterval(() => {
      setUpdateCount(x => x + 1);
    }, refreshRate * 1000);

    return () => window.clearInterval(interval.current);
  }, [setUpdateCount, refreshRate]);

  const formatted = dayjs().to(dayjs(untilDate), true);

  if (untilDate > now && isEndingSoon) {
    return (
      <>
        {prefix && `${prefix} `}
        <SaleCountdown
          hideZeroes
          size="small"
          to={until}
          showRedText={useRedText}
        />
        {suffix && ` ${suffix}`}
      </>
    );
  }

  return (
    <span
      className={cx({ 'tw-text-red-500': isEndingSoon })}
      title={`Until ${untilDate}`}>
      {untilDate > now
        ? `${prefix} ${formatted} ${suffix}`
        : `${endedText} ${formatted} ago`}
    </span>
  );
}
